export function getDuration(start, end) {
  const start_date = new Date(start);
  const end_date = new Date(end);

  // Validasi tanggal
  if (isNaN(start_date.getTime()) || isNaN(end_date.getTime())) {
    console.error("Invalid date format");
    return null;
  }

  let diffMs = end_date.getTime() - start_date.getTime(); // selisih ms

  if (diffMs < 0) diffMs = -diffMs; // jika ingin hasil selalu positif

  const totalMinutes = Math.floor(diffMs / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  return formatDurationDetail(days, hours, minutes);
}

function formatDurationDetail(days, hours, minutes) {
  const parts = [];
  if (days > 0) parts.push(`${days} days`);
  if (hours > 0) parts.push(`${hours} hours`);
  if (minutes > 0) parts.push(`${minutes} minutes`);

  return parts.length > 0 ? parts.join(" ") : "0 minutes";
}
